export function scrollToCabinAnchor(id: string): boolean {
  const el = document.getElementById(id)
  const scroller = document.querySelector('main.mma-main')
  if (!el) return false
  if (scroller instanceof HTMLElement) {
    const top = el.getBoundingClientRect().top - scroller.getBoundingClientRect().top + scroller.scrollTop - 8
    scroller.scrollTo({ top: Math.max(0, top), behavior: 'smooth' })
    return true
  }
  el.scrollIntoView({ behavior: 'smooth', block: 'start' })
  return true
}

export const LIMITS_SCROLL_EVENT = 'p2p:scroll-limits'